import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Header from './Header';

export default function AppLoader() {
  return (
    <>
      <Header />
      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={true}>
        <CircularProgress color="primary" />
      </Backdrop>
    </>
  );
}
